import { AttachmentResult } from '@sdir/httpclient/lib/clients/aps/application';
import { useCallback, useEffect, useState } from 'react';
import { useCurrentApplication } from './useCurrentApplication';
import { Loadable } from '../../types';

export const useAppAttachmentFile = (appAttachment: AttachmentResult | null): Loadable<File> => {
  const [downloadedFile, setDownloadedFile] = useState<File>();
  const [fileError, setFileError] = useState<Error | null>(null);

  const { getAttachment } = useCurrentApplication();

  const loadFile = useCallback(
    (attachment: AttachmentResult) => {
      setDownloadedFile(undefined);
      setFileError(null);
      getAttachment?.(attachment).then(setDownloadedFile).catch(setFileError);
    },
    [getAttachment]
  );

  useEffect(() => {
    if (appAttachment) {
      loadFile(appAttachment);
    }
  }, [appAttachment, loadFile]);

  if (!appAttachment) return {};

  if (downloadedFile) return { result: downloadedFile };
  if (fileError) return { error: fileError };
  return { loading: true };
};
